<template>
	<v-app class="vo-mlm">
		<router-view/>
		<v-overlay
      :z-index="zIndex"
			:opacity="opacity"
      :value="overlay"
    >
			<center>
				<v-icon size="90" style="font-weight: 300;">mdi-access-point-network-off</v-icon>
			</center>
      <h2 class="text-center font-weight-400 mt-5">
				<b>Anda sedang Offline.</b>
			</h2>
			<h4 class="text-center font-weight-400 mt-2 px-2">
				Kemungkinan koneksi internet anda sedang terputus, silahkan periksa kembali koneksi internet Anda.
			</h4>
    </v-overlay>

		<v-snackbar v-model="errResponse" timeout="4000" right top color="red darken-2">
			<div v-if="errResponse"><v-icon dense small class="mr-2">mdi-alert</v-icon>{{ errResponse }}</div>
		</v-snackbar>
	</v-app>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex';
import { client } from '@/api/client';

export default {
	name: 'App',

	data: () => ({
		onLine: navigator.onLine,
		overlay: false,
		opacity: 0.65,
		zIndex: 999,
		errResponse: null
	}),
	computed: {
		...mapState(['snackbar', 'errorAlert']),
		...mapState(['pageTitle']),

		isIdle() {
      return this.$store.state.idleVue.isIdle
    },

		title() {
			return `${this.pageTitle} - VO`;
		},
	},
	methods: {
		...mapActions('auth', ['logout']),
		...mapMutations(['setErrorAlert']),

		forceLogoutVO() {
			this.logout().then(() => {
				this.$router.push({ name: 'login' }).catch(()=>{});
			});
		},
		updateOnlineStatus(e) {
			const { type } = e;
			this.onLine = type === 'online';
		}
	},
	watch: {
		pageTitle(val, oldVal) {
			if (val !== oldVal) {
				document.title = this.title;
			}
		},
		onLine(v) {
			if (v) {
				this.overlay = false
			} else {
				this.overlay = true
			}
		},
		// eslint-disable-next-line no-unused-vars
		isIdle: function(newIdle, recentIdle) {
			const authData = localStorage.getItem('mlmcore-vo-auth-data')
			if (newIdle && authData) this.forceLogoutVO()
    }
	},
	created() {
		client.interceptors.response.use(undefined, (error) => {
			return new Promise(() => {
				if (error.response.status === 401) {
					this.errResponse = error.response.data.message
					// setTimeout(() => {
						this.forceLogoutVO()
					// }, 2000)
				}
				throw error;
			});
		});
	},
	mounted() {
		if (window.location.protocol == 'http:') window.location.href = window.location.href.replace('http:', 'https:')

		window.addEventListener('online', this.updateOnlineStatus);
		window.addEventListener('offline', this.updateOnlineStatus);
		if (this.onLine === false) {
			this.overlay = true
		} else {
			this.overlay = false
			// location.reload()
		}
	},
	beforeDestroy() {
		window.removeEventListener('online', this.updateOnlineStatus);
		window.removeEventListener('offline', this.updateOnlineStatus);
	}
};
</script>

<style lang="scss">
@import "./styles/color-theme/green";
@import "./styles/theme";
@import "./styles/page";
@import "./styles/responsive";
@import "~vue-wysiwyg/dist/vueWysiwyg.css"
</style>